import { useState } from "react";
import {
    FaClipboardCheck, FaCheckCircle, FaLock, FaDatabase,
    FaMinus, FaPlus,
    FaExchangeAlt,

    FaUsers
} from "react-icons/fa";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";


const services = [
    {
        "title": "Healthcare Interoperability Strategy Development",
        "description": "Develop a comprehensive strategy to enhance healthcare data exchange, ensuring seamless integration across disparate systems. Improve operational efficiency, reduce integration costs, accelerate client onboarding, and maintain full HIPAA compliance for secure and reliable data sharing."
    },
    {
        "title": "Healthcare Interoperability Auditing",
        "description": "Create a structured, actionable roadmap to achieve interoperability goals. Define key milestones, assess existing capabilities, implement industry best practices, and establish a phased technology adoption plan for streamlined healthcare data connectivity."
    },
    {
        "title": "Data Migration & Integration Support",
        "description": "Optimize interoperability by structuring and mapping healthcare data across various platforms. Enhance workflow documentation to improve efficiency, reduce errors, and ensure seamless access to accurate patient information across systems."
    },
    {
        "title": "EHR & Health IT Solutions for CMS Compliance",
        "description": "Empower healthcare professionals with specialized training on interoperability standards, regulatory compliance, and best practices. Provide hands-on education in FHIR, HL7, and other industry protocols to enhance data-sharing capabilities."
    },
    {
        "title": "CMS Compliance Training & Education",
        "description": "Our training programs ensure that healthcare teams are knowledgeable about CMS regulations and how to implement compliant practices."
    },
    {
        "title": "Data Integration & Reporting for Healthcare Providers",
        "description": "We help healthcare organizations integrate their data systems and generate CMS-compliant reports, ensuring that all necessary data is tracked and submitted."
    },
    // {
    //     "title": "API Development for Healthcare Interoperability",
    //     "description": "Design and develop secure, scalable APIs to enable real-time healthcare data exchange. Ensure compatibility with existing healthcare IT systems, optimize performance, and maintain strict compliance with industry regulations."
    // },
    // {
    //     "title": "HIPAA & Compliance Consulting",
    //     "description": "Deliver expert consulting on HIPAA, CMS, and other regulatory requirements to ensure full compliance with healthcare data security and privacy laws. Conduct risk assessments, implement security safeguards, and provide ongoing compliance monitoring."
    // }
]


const CMSMandates = () => {
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <>
            {/* <div className="min-h-screen bg-gradient-to-t from-[#78ffa5] to-[#03ab3b]   w-full flex flex-col items-center py-12 px-6"> */}
            <div className="min-h-screen bg-white   w-full flex flex-col items-center py-6 mt-10 px-2">
                {/* Header Section */}
                <div className="w-full text-center">
                    <h1 className=" text-[30px] font-semibold text-gray-800 
                 bg-gradient-to-r from-[#2a627a] to-transparent 
                 rounded-xl mb-4 p-4 shadow-lg">
                        HIKEHEALTH GS -
                        <span className="relative inline-block mx-1 font-semibold text-[#2a627a]">
                            CMS Mandates
                        </span>
                    </h1>

                    <p className="text-gray-800 mt-3 text-[15px] max-w-2xl mx-auto">
                        Ensuring compliance with CMS interoperability regulations while enhancing patient access and data security.
                    </p>
                </div>


                {/* Key Features Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8 max-w-5xl mx-auto">
                    <FeatureCard
                        icon={<FaCheckCircle className="text-[#2a627a] text-5xl mb-4" />}
                        title="Guaranteed CMS Compliance"
                        description="Stay ahead of regulatory requirements with secure, FHIR-based data exchange."
                    />
                    <FeatureCard
                        icon={<FaLock className="text-[#2a627a] text-5xl mb-4" />}
                        title="Enhanced Data Security"
                        description="Protect patient data with end-to-end encryption and secure APIs."
                    />
                    <FeatureCard
                        icon={<FaDatabase className="text-[#2a627a] text-5xl mb-4" />}
                        title="FHIR-Based Interoperability"
                        description="Enable seamless data exchange between payers, providers, and patients."
                    />
                    <FeatureCard
                        icon={<FaUsers className="text-[#2a627a] text-5xl mb-4" />}
                        title="Seamless Patient Access"
                        description="Empower patients with real-time access to their health records via API."
                    />
                    <FeatureCard
                        icon={<FaClipboardCheck className="text-[#2a627a] text-5xl mb-4" />}
                        title="Automated Compliance Audits"
                        description="Easily track and monitor regulatory compliance with automated audits."
                    />
                    {/* <FeatureCard
                        icon={<FaExchangeAlt className="text-[#2a627a] text-5xl mb-4" />}
                        title="Effortless Payer-to-Payer Exchange"
                        description="Ensure smooth data transfer between payers with industry-standard protocols."
                    /> */}
                </div>


                {/* CMS Mandates Section */}
                <div className="bg-gray-200 mt-10 p-8 rounded-2xl shadow-xl w-full max-w-5xl mx-auto">
                    <h2 className="text-[30px] font-extrabold text-[#2a627a] text-center relative inline-block">
                        CMS Mandates
                        <span className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-full h-1  bg-yellow-400 rounded-full"></span>
                    </h2>

                    <p className="text-gray-800 mt-4 text-center text-sm leading-relaxed">
                        CMS regulations require healthcare organizations to enhance <span className="text-[#2a627a] font-bold">Interoperability</span>  and patient data access  through <span className="text-[#2a627a] font-bold">FHIR-based APIs</span> .
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-4">
                        <div className="flex items-center space-x-4 bg-gray-300 p-5 rounded-lg shadow-md">
                            <span className="text-green-600 text-xl">✔️</span>
                            <p className="text-gray-700 font-medium text-sm">Patient Access API</p>
                        </div>
                        <div className="flex items-center space-x-4 bg-gray-300 p-5 rounded-lg shadow-md">
                            <span className="text-blue-600 text-xl">✔️</span>
                            <p className="text-gray-700 font-medium text-sm">Provider Directory API</p>
                        </div>
                        <div className="flex items-center space-x-4 bg-gray-300 p-5 rounded-lg shadow-md">
                            <span className="text-purple-600 text-xl">✔️</span>
                            <p className="text-gray-700 font-medium text-sm">Payer-to-Payer Data Exchange</p>
                        </div>
                        <div className="flex items-center space-x-4 bg-gray-300 p-5 rounded-lg shadow-md">
                            <span className="text-red-600 text-xl">✔️</span>
                            <p className="text-gray-700 font-medium text-sm">Prior Authorization Requirements</p>
                        </div>
                        <div className="flex items-center space-x-4 bg-gray-300 p-5 rounded-lg shadow-md">
                            <span className="text-yellow-600 text-xl">✔️</span>
                            <p className="text-gray-700 font-medium text-sm">Real-Time Benefit Tools</p>
                        </div>
                        <div className="flex items-center space-x-4 bg-gray-300 p-5 rounded-lg shadow-md">
                            <span className="text-teal-600 text-xl">✔️</span>
                            <p className="text-gray-700 font-medium text-sm">Improved Claims Processing</p>
                        </div>
                    </div>
                </div>


                {/* Health Plan Requirements Section */}
                <div className=" mt-10 w-full  mx-auto">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Empowering Patients with Seamless Access
                    </h2>
                    <div className="max-w-4xl grid grid-cols-1 md:grid-cols-1 gap-6 mt-2 mx-auto px-2">

                        <p className="text-gray-800  text-center text-sm leading-relaxed">
                            Health plans must provide secure, real-time access to patient information through a
                            <span className="font-semibold text-[#2a627a]"> FHIR-based API</span>.
                        </p>

                        <p className="text-lg -mt-1 font-semibold text-center  text-[#2a627a]">
                            Secure | Fast | Reliable
                        </p>

                        {/* Grid Layout with Tick Marks */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-1">
                            {[
                                "Seamless Payer-to-Payer Data Exchange",
                                "Compliant Qualified Health Plans",
                                "Medicare Advantage Support",
                                "Medicaid Fee-for-Service Solutions",
                                "CHIP FFS Program Security",
                                "Medicaid Managed Care Integration",
                                "CHIP Managed Care Optimization"
                            ].map((text, index) => (
                                <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                    whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                    transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>

                                    <span className="text-green-500 text-xl font-bold">✔</span>
                                    <p className="text-gray-800 text-sm font-medium">{text}</p>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </div>


                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-4xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

/* Feature Card Component */
const FeatureCard = ({ icon, title, description }) => (
    <motion.div
        className="p-6 bg-gray-300 bg-opacity-70 hover:border-[#2a627a] border hover:bg-gray-300 group shadow-xl drop-shadow-lg rounded-xl flex flex-col items-center text-center transition-all duration-300 hover:shadow-xl"
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 0.6, ease: "easeOut", bounce: 0.3 }}
    >
        {icon}
        <h2 className="text-lg font-bold text-[#2a627a]">{title}</h2>
        <p className="text-gray-800 text-sm mt-2">{description}</p>
    </motion.div>
);
export default CMSMandates;
